import * as React from 'react';
import './RegionCard.less';
import { replaceSpaceByDash } from '../../utils/helpers';

interface Props {
  region: any;
  onClick?: (country: any) => void;
}

const RegionCard: React.FunctionComponent<Props> = ({
  region,
  onClick = () => null,
}) => (
  <div className="region-card" onClick={() => onClick(region)}>
    <span>{replaceSpaceByDash(region.name)}</span>
  </div>
);

export default RegionCard;



// WEBPACK FOOTER //
// ./src/components/RegionCard/RegionCard.tsx